import { render } from "./EditBranding.vue?vue&type=template&id=78ef1e6d&scoped=true"
import script from "./EditBranding.vue?vue&type=script&lang=js"
export * from "./EditBranding.vue?vue&type=script&lang=js"

import "./EditBranding.vue?vue&type=style&index=0&id=78ef1e6d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78ef1e6d"]])

export default __exports__